import { Injectable } from '@angular/core';
import { Tenant } from '../../contracts/models/tenant.model';
import { map } from 'rxjs/operators';
import { UserDto, User } from '../../contracts/models/user.model';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { ApiResult } from '../../contracts/types/api-response.type';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TenantLocalService } from 'src/app/core/services/api/tenantlocal.service';

@Injectable({ providedIn: 'root' })
export class TenantService extends Api {

    private selectedTenantId: number | null = null;


    getTenants(): Observable<Tenant[]> {
        return this.http.get<{ tenants: Tenant[] }>(`${this.url}/tenants`).pipe(
            map(response => response.tenants)
        );
    }

    createTenant(data: Tenant): Observable<Tenant> {
        return this.http.post<Tenant>(`${this.url}/tenants`, data);
    }

    getTenantbySlug(slug: string): Observable<Tenant> {
        return this.http.get<Tenant>(`${this.url}/tenants/mostrarBySlug/${slug}`);
    }

    // tenant.service.ts seleccionar tenant 
    setTenantInBackend(tenantId: string): Observable<any> {
        return this.http.post<any>(`${this.url}/tenants/select`, { tenant_id: tenantId });
    }


}

